import { render } from "./Rid.vue?vue&type=template&id=5641b8a1&scoped=true"
import script from "./Rid.vue?vue&type=script&lang=js"
export * from "./Rid.vue?vue&type=script&lang=js"

import "./Rid.vue?vue&type=style&index=0&id=5641b8a1&scoped=true&lang=css"
import "./Rid.vue?vue&type=style&index=1&id=5641b8a1&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5641b8a1"]])

export default __exports__